import {DropdownListItem} from "../../components/forms/dropdownListForm";
import moment from "moment-timezone";
import {Language, TimeFormat} from "../../util/enum";
import {RadioItem} from "../../components/forms/radioForm";
import {TemplateContent} from "./templateEditContentList";
import {
    AppointmentReminderDefaultState,
    AppointmentReminderSecondState,
    AppointmentReminderThirdState,
    EditorEmptyRawState,
} from "./templateEditorDefaultState";
import {GroupSource} from "./groupSelection";
import {AutomatedCampaignType, CampaignBigType, CampaignType} from "./dataForActiveCampaign";
import {AppointmentReminderTemplateID} from "./designCampaign";
import {MessageTemplateContent} from "./campaignService";
import {getCompliedMessageFromLibMessage} from "./templateEditor";
import {isDebug} from "../../appConfig";
import {SelectPatient} from "../patients/patientPreviewList";

export enum FireType {
    scheduleLater,
    sendNow
}

export enum BeforeDayForAutomatedCampaign {
    day0 = 0,
    day1 = 1,
    day2 = 2,
    day3 = 3,
    week1 = 7
}

export interface AutomatedCampaignFilter {
    fromAge: string,
    toAge: string,
    planType: any,
}

export interface CampaignSetting {
    campaignId: string,
    relationId: string,
    olid: number,
    groupSource: GroupSource,
    groupId: string,
    groupName: string,
    campaignBigType: CampaignBigType,
    automatedCampaignType: AutomatedCampaignType,
    matchingCount: number,
    excludePatients: Array<SelectPatient>,

    campaignName: string,
    messagePerDay: number,
    fireType: FireType,
    startDate: Date,
    endDate: Date,
    sendDateTime: string,
    // 0 is yes, 1 is no
    recurringCampaign: number,
    campaignType: CampaignType,
    templateId: string,
    beforeDay: BeforeDayForAutomatedCampaign,
    filter: AutomatedCampaignFilter
}

export const dataFoRecurrence: Array<DropdownListItem> = [
    // {name: "Send Once", id: CampaignType.sendOnce},
    {name: "Weekly", id: CampaignType.sendWeekly},
    {name: "Bi-weekly", id: CampaignType.sendBiWeekly},
    {name: "Monthly", id: CampaignType.sendMonthly},
    {name: "Quarterly", id: CampaignType.sendQuarterly},
    // {name: "Yearly", id: CampaignType.yearly},
]

export const dataFoAppointmentReminder: Array<DropdownListItem> = [
    {name: "1 day before the appointment", id: BeforeDayForAutomatedCampaign.day1},
    {name: "2 days before the appointment", id: BeforeDayForAutomatedCampaign.day2},
    {name: "3 days before the appointment", id: BeforeDayForAutomatedCampaign.day3},
    {name: "1 week before the appointment", id: BeforeDayForAutomatedCampaign.week1},
]

export const dataForPostAppointment: Array<DropdownListItem> = [
    {name: "1 day after the appointment", id: BeforeDayForAutomatedCampaign.day1},
    {name: "2 days after the appointment", id: BeforeDayForAutomatedCampaign.day2},
    {name: "3 days after the appointment", id: BeforeDayForAutomatedCampaign.day3},
]

export const dataForMessagePerDay: Array<DropdownListItem> = [{name: "Max 200 per day", id: 200}, {name: "Max 500 per day", id: 500}, {name: "Max 1000 per day", id: 1000}, {name: "Max 2000 per day", id: 2000}, {name: "Max 5000 per day", id: 5000}]
export const dataForFireType : Array<RadioItem> = [{name: "Schedule for Later", id: FireType.scheduleLater}, {name: "Send Now", id: FireType.sendNow}]
export const dataForIsRecurring : Array<RadioItem> = [{name: "Yes", id: 0}, {name: "No", id: 1}]

export const getDefaultDataForTemplateLanguage = (defaultRawState: string = EditorEmptyRawState ): Array<TemplateContent> => {
    const maxLength: number = 640
    return [
        {language: Language.english, id: 0, name: "English", compliedMessage: "", libMessage: defaultRawState, maxlength: maxLength},
        {language: Language.simplifiedChinese, id: 1, name: "Simplified Chinese", compliedMessage: "", libMessage: defaultRawState, maxlength: maxLength},
        {language: Language.traditionalChinese, id: 2, name: "Traditional Chinese", compliedMessage: "", libMessage: defaultRawState, maxlength: maxLength},
        {language: Language.spanish, id: 3, name: "Spanish", compliedMessage: "", libMessage: defaultRawState, maxlength: maxLength},
        {language: Language.russian, id: 4, name: "Russian", compliedMessage: "", libMessage: defaultRawState, maxlength: maxLength},
        {language: Language.bengali, id: 5, name: "Bengali", compliedMessage: "", libMessage: defaultRawState, maxlength: maxLength},
        {language: Language.korean, id: 6, name: "Korean", compliedMessage: "", libMessage: defaultRawState, maxlength: maxLength},
        {language: Language.hindi, id: 7, name: "Hindi", compliedMessage: "", libMessage: defaultRawState, maxlength: maxLength},
    ]
}

export const predefinedTemplateLanguages = [Language.english, Language.simplifiedChinese, Language.traditionalChinese, Language.korean]
export const koreanClinics = isDebug ? [] : [3494, 3497]

export const getDefaultAppointmentDataForTemplateLanguage = (appointmentState: (language: Language) => string = AppointmentReminderDefaultState): Array<TemplateContent> => {
    const list = getDefaultDataForTemplateLanguage().filter((item) => predefinedTemplateLanguages.includes(item.language))
    return list.map((item) => {
        const _item = Object.assign({}, item)
        _item.libMessage = appointmentState(item.language)
        _item.compliedMessage = getCompliedMessageFromLibMessage(_item.libMessage)
        return _item
    })
}

// const formatSendDateTime = (date: Date) => {
//     const m = moment(date)
//     const min = m.minutes()
//     const minList = [0, 15, 30, 45, 60]
//     let targetMin = 0
//     if (m.isAfter(moment(), "minute")) {
//         targetMin = minList[0]
//     } else {
//         targetMin = minList.find((num) => num > min) || 0
//     }
//     let hour = m.hours()
//     if (targetMin === 60) {
//         hour = hour + 1
//         targetMin = 0
//     }
//     return `${hour < 10 ? "0" + hour : hour}:${targetMin < 10 ? "0" + targetMin : targetMin}`
// }

const NewYorkTimeZone = "America/New_York"

/**
 * @Desc   generate start date, based on new york(EST) time zone
 * @Params
 * @Return
*/
const generateStartDate = () => {
    const m = moment().tz(NewYorkTimeZone)
    if (m.hour() < 8) {
        return new Date(m.year(), m.month(), m.date(), 8, 0, 0, 0)
    } else if (m.hour() >= 21) {
        const tmr = m.add(1, "day")
        return new Date(tmr.year(), tmr.month(), tmr.date(), 8, 0, 0, 0)
    }
    const min = m.minute()
    const minList = [0, 15, 30, 45, 60]
    const targetMin = minList.find((num) => num > min) || 0
    if (targetMin === 60) {
        return new Date(m.year(), m.month(), m.date(), m.hour() + 1, 0, m.second(), m.millisecond())
    }
    return new Date(m.year(), m.month(), m.date(), m.hour(), targetMin, m.second(), m.millisecond())
}

/**
 * @Desc   validate date, based on new york(EST) time zone
 * @Params
 * @Return
*/
export const validateDateTime = (date: Date, time: string) => {
    // const dateStr = moment(date).format(TimeFormat.MMDDYYYY)
    // const newDate = moment(`${dateStr} ${time}`, TimeFormat.MMDDYYYYHHmm)
    // const nym = moment().tz(NewYorkTimeZone)
    // const now = moment(new Date(nym.year(), nym.month(), nym.date(), nym.hour(), nym.minute(), nym.second(), nym.millisecond()))
    // return newDate.isAfter(now, "minute")
    return offsetMinutesWithDateTime(date, time) > 0
}

/**
 * @Desc   offset minutes, based on new york(EST) time zone
 * @Params
 * @Return
*/
export const offsetMinutesWithDateTime = (date: Date, time: string) => {
    const dateStr = moment(date).format(TimeFormat.MMDDYYYY)
    const newDate = moment(`${dateStr} ${time}`, TimeFormat.MMDDYYYYHHmm)
    const nym = moment().tz(NewYorkTimeZone)
    const now = moment(new Date(nym.year(), nym.month(), nym.date(), nym.hour(), nym.minute(), nym.second(), nym.millisecond()))
    return newDate.diff(now, "minute")
}

/**
 * @Desc   convert date to UTC, based on new york(EST) time zone
 * @Params
 * @Return
*/
export const convertDateTimeToUTC = (date: Date, dateTime: string) => {
    const dateStr = moment(date).format(TimeFormat.MMDDYYYY);
    const newDate = moment(`${dateStr} ${dateTime}`, TimeFormat.MMDDYYYYHHmm)
    const nym = moment.tz(newDate.format(TimeFormat.YYYYMMDDTHHmmss), NewYorkTimeZone)
    return nym.toISOString()
}

export const convertToESTDate = (date: Date) => {
    const nym = moment(date).tz(NewYorkTimeZone)
    return new Date(nym.year(), nym.month(), nym.date(), nym.hour(), nym.minute(), nym.second(), nym.millisecond())
}

export const getDefaultCampaignSetting = (officeId: number): CampaignSetting => {
    const startDate = generateStartDate()

    return {
        campaignId: "",
        relationId: "",
        olid: officeId,
        groupSource: GroupSource.custom,
        groupId: "",
        campaignBigType: CampaignBigType.regularCampaign,
        automatedCampaignType: AutomatedCampaignType.none,
        groupName: "",
        matchingCount: 0,
        excludePatients: [],
        campaignName: "",
        messagePerDay: dataForMessagePerDay[0].id,
        fireType: 0,
        startDate: startDate,
        sendDateTime: moment(startDate).format(TimeFormat.HHmm),
        recurringCampaign: 1,
        campaignType: CampaignType.sendOnce,
        endDate: startDate,
        templateId: "",
        beforeDay: BeforeDayForAutomatedCampaign.day1,
        filter: {
            fromAge: "",
            toAge: "",
            planType: "",
        },
    }
}

export const getDefaultCampaignTemplates = (): Array<MessageTemplateContent> => {
    return [{templateId: "", name: "-----", templateContent: getDefaultDataForTemplateLanguage()}]
}

export const getDefaultAppointmentReminderTemplates = (): Array<MessageTemplateContent> => {
    return [
        {templateId: AppointmentReminderTemplateID.primary, name: "Appointment Reminder - Primary", templateContent: getDefaultAppointmentDataForTemplateLanguage(AppointmentReminderDefaultState)},
        {templateId: AppointmentReminderTemplateID.followUpWithURL, name: "Appointment Reminder - Follow up (with URL)", templateContent: getDefaultAppointmentDataForTemplateLanguage(AppointmentReminderSecondState)},
        {templateId: AppointmentReminderTemplateID.followUpWithoutURL, name: "Appointment Reminder - Final (without URL)", templateContent: getDefaultAppointmentDataForTemplateLanguage(AppointmentReminderThirdState)},
    ]
}
